module.exports = __webpack_public_path__ + "img/speed-sd.4c37b053.png";